module.exports={otherOrganizations:"Altre organizzazioni",solutionIframe:"Contenuto principale",unloadPromptMessage:"Vuoi procedere?"};